module.exports = __webpack_public_path__ + "static/media/10.cb541d0e.jpg";